<template>
  <div>
    <!-- FIXME: 這裡照理 hidden 要在 subjects assign to data 時就處理乾淨，不該留在 template 層清洗-->
    <!-- NOTE: 此處的 hidden 相關邏輯為複製 MemberCenterEdit.vue & RegisterMember.vue 的動態編輯欄位相關程式所殘留的邏輯，實際上並未運作，在 DynamicFormEditor 也沒有使用之-->
    <div
      v-for="(subject, index) in subjects.filter((x) => {
        return x.hidden == undefined || !x.hidden;
      })"
      :key="`field.${index}`"
      class="field"
    >
      <!-- type: text start -->
      <template v-if="subject.type === 'text'">
        <SubjectLayout
          :subject="subject"
          :validateError="v$.form[`${subject.id}`].$error"
        >
          <!-- Phone verification input (self-contained) -->
          <PhoneVerification
            v-if="isPhoneVerificationField(subject)"
            ref="phoneVerification"
            v-model="form[`${subject.id}`]"
            :placeholder="displayPlaceholder(subject)"
            :validation-error="v$.form[`${subject.id}`].$error"
            :field-memo="subject.memo"
            :should-load-customer-data="subject.assign_to_customer_data === 'mobile_phone'"
            :should-sync-customer-data="subject.save_to_customer_data === 'mobile_phone'"
          />

          <!-- Regular text input -->
          <input
            v-else
            class="field__input"
            v-model="form[`${subject.id}`]"
            :class="{ invalid: v$.form[`${subject.id}`].$error }"
            :placeholder="displayPlaceholder(subject)"
            :disabled="subject.disabled"
          />
        </SubjectLayout>
      </template>
      <!-- type: text end -->

      <!-- type: textarea start -->
      <template v-if="subject.type === 'textarea'">
        <SubjectLayout
          :subject="subject"
          :validateError="v$.form[`${subject.id}`].$error"
        >
          <textarea
            class="field__input"
            v-model="form[`${subject.id}`]"
            :class="{ invalid: v$.form[`${subject.id}`].$error }"
            :placeholder="displayPlaceholder(subject)"
            :disabled="subject.disabled"
            v-bind:rows="subject.rows"
          ></textarea>
        </SubjectLayout>
      </template>
      <!-- type: textarea end -->

      <!-- type: select start -->
      <template v-if="subject.type === 'select'">
        <SubjectLayout
          :subject="subject"
          :validateError="v$.form[`${subject.id}`].$error"
        >
          <SharedSelect
            v-model="form[`${subject.id}`]"
            :options="availableOptions(subject)"
            :hasBorder="false"
            :placeholder="displayPlaceholder(subject)"
            :disabled="subject.disabled"
             :class="{ invalid: v$.form[`${subject.id}`].$error }"
          />
        </SubjectLayout>
      </template>
      <!-- type: select end -->

      <!-- type: radio start -->
      <template v-if="subject.type === 'radio'">
        <SubjectLayout
          :subject="subject"
          :validateError="v$.form[`${subject.id}`].$error"
        >
          <div class="row">
            <div
              class="col-12 col-sm-6 px-2"
              v-for="(option, optionIndex) in availableOptions(subject)"
              :key="index + '-' + optionIndex"
            >
              <SharedRadioButton
                v-model="form[`${subject.id}`]"
                :id="subject.id + '-' + optionIndex"
                :value="option.value"
                :name="subject.id"
                :disabled="subject.disabled"
              >
                {{ option.text }}
              </SharedRadioButton>
            </div>
          </div>
        </SubjectLayout>
      </template>
      <!-- type: radio end -->

      <!-- type: checkbox start -->
      <template v-if="subject.type === 'checkbox'">
        <SubjectLayout
          :subject="subject"
          :validateError="v$.form[`${subject.id}`].$error"
        >
          <div class="row">
            <div
              class="col-12 col-sm-6 px-2"
              v-for="(option, optionIndex) in availableOptions(subject)"
              :key="index + '-' + optionIndex"
            >
              <SharedCheckbox
                v-model="form[`${subject.id}`]"
                :id="index + '-' + optionIndex"
                :value="option.value"
                :name="subject.id"
                :disabled="subject.disabled"
              >
                {{ option.text }}
              </SharedCheckbox>
            </div>
          </div>

          <!-- <b-form-checkbox-group
            v-model="form[`${subject.id}`]"
            :stacked="subject.is_vertical"
            :disabled="subject.disabled"
            class="row"
          >
          <div class="col-12 col-sm-6 px-2" :class="form[`${subject.id}`] && form[`${subject.id}`].includes(option.value) && 'active'" v-for="(option,optionIndex) in subject.options" :key="optionIndex">
            <b-form-checkbox :value="option.value">{{ option.text }}</b-form-checkbox>
          </div>
        </b-form-checkbox-group> -->
        </SubjectLayout>
      </template>
      <!-- type: checkbox end -->

      <!-- type: datetime start -->
      <template v-if="subject.type === 'datetime'">
        <SubjectLayout
          :subject="subject"
          :validateError="v$.form[`${subject.id}`].$error"
        >
          <template v-if="subject.format === 'datetime'">
            <DynamicFormDateTimePicker
              v-model="form[`${subject.id}`]"
              :placeholder-for-date="displayPlaceholder(subject)"
              :placeholder-for-time="displayPlaceholder(subject) || ' '"
              :has-error="v$.form[`${subject.id}`].$error"
              :daily-time="subject.daily_time"
              :time-condition="subject.time_condition"
              :start-time="subject.start_time"
              :end-time="subject.end_time"
              :slot-minutes="subject.slot_minutes"
              :time-style="subject.time_style"
              :isLoading="branchFetching"
              :date-condition="subject.date_condition"
              :date-time-options="subject.options"
              :custom-time-options="subject.time_options"
              :disabled="subject.disabled"
              :optionDisabler="(date, time) => optionDisabler(subject, {date, time})"
              @input="value => handleFieldValueChanged(value, subject)"
            />
          </template>
          <template v-if="subject.format === 'date'">
            <DynamicFormDatePicker
              v-model="form[`${subject.id}`]"
              :placeholder="displayPlaceholder(subject)"
              :has-error="v$.form[`${subject.id}`].$error"
              :date-options="subject.options"
              :date-type="subject.date_condition"
              :isLoading="branchFetching"
              :disabled="subject.disabled"
              @input="value => handleFieldValueChanged(value, subject)"
            />
          </template>
          <template v-if="subject.format === 'time'">
            <DynamicFormTimePicker
              v-model="form[`${subject.id}`]"
              :placeholder="displayPlaceholder(subject) || ' '"
              :has-error="v$.form[`${subject.id}`].$error"
              :style-type="subject.time_condition"
              :start-time="subject.start_time"
              :end-time="subject.end_time"
              :slot-minutes="subject.slot_minutes"
              :time-style="subject.time_style"
              :isLoading="branchFetching"
              :disabled="subject.disabled"
              :custom-time-options="subject.time_options"
              @input="value => handleFieldValueChanged(value, subject)"
            />
          </template>
        </SubjectLayout>
      </template>
      <!-- type: datetime end -->

      <!-- type: uploader start -->
      <template v-if="subject.type === 'uploader'">
        <SubjectLayout
          :subject="subject"
          :validateError="v$.form[`${subject.id}`].$error"
        >
          <AppFileUploader
            v-model="form[`${subject.id}`]"
            :has-error="v$.form[`${subject.id}`].$error"
            placeholder-when-uploaded="（查看檔案）"
            placeholder-when-empty=""
            :showDeletedAction="!subject.disabled"
            @uploading="handleFileUploading"
          />
        </SubjectLayout>
      </template>
      <!-- type: uploader end -->

      <!-- type: collection select start -->
      <template v-if="subject.type === 'collection_select'">
        <CollectionSelect
          :subject="subject"
          :ref="`collection-select-${subject._id}`"
          :branch-id="getBranchIdByFieldId(subject.branch_field_id)"
          :is-related-to-branch="!!subject.branch_field_id"
          v-model="form[`${subject.id}`]"
          :optionDisabler="(option) => optionDisabler(subject, option)"
          :placeholder="displayPlaceholder(subject, '請選擇')"
          :validateError="v$.form[`${subject.id}`].$error"
          @input="value => handleFieldValueChanged(value, subject)"
        >
        </CollectionSelect>
      </template>
      <!-- type: collection select end -->

      <!-- type: collection carousel start -->
      <template v-if="subject.type === 'collection_carousel'">
        <SubjectLayout
          :subject="subject"
          :validateError="v$.form[`${subject.id}`].$error"
        >
          <CarouselSelection
            v-model="form[`${subject.id}`]"
            :ref="`collection-carousel-${subject._id}`"
            :placeholder="displayPlaceholder(subject, '請選擇')"
            :candidate-fetcher="() => fetchCollectionItemsForCarousel(subject, subject.branch_field_id)"
            :disabled="(false === carouselSelectionIsEnabled(subject)) || subject.disabled"
            :value-matcher="matchCandidateForCollectionCarousel"
            :has-error="v$.form[`${subject.id}`].$error">
          </CarouselSelection>
        </SubjectLayout>
      </template>
      <!-- type: collection carousel end -->

      <!-- type: shop selection start -->
      <template v-if="subject.type === 'shop_selection'">
        <SubjectLayout
          :subject="subject"
          :validateError="v$.form[`${subject.id}`].$error"
        >
          <ShopSelection
            v-if="deepGet(subject, 'branch_population', 'all') === 'all'"
            :value="deepGet(form[`${subject.id}`], 'value')"
            @selected="(event) => handleShopSelectionChange(event, subject)"
            :ref="`shop-selection-${subject._id}`"
            :branch-provider="subject.branch_provider || ''"
            :show-branch-code="subject.show_branch_code || false"
            :placeholder="subject.default_select_text || '請選擇'"
            :disabled="subject.disabled"
            :optionDisabler="(option) => optionDisabler(subject, option)"
          />
          <ShopSubsetSelection
            v-if="deepGet(subject, 'branch_population', 'all') === 'subset'"
            :value="deepGet(form[`${subject.id}`], 'value')"
            @selected="(event) => handleShopSubsetSelectionChange(event, subject)"
            :ref="`shop-subset-selection-${subject._id}`"
            :branch-ids="subject.branch_ids || ''"
            :show-parent-branches="subject.show_parent_branch_options"
            :parent-branch-population="subject.parent_branch_population || 'parent'"
            :parent-branch-provider="subject.parent_branch_provider || null"
            :show-branch-code="subject.show_branch_code || false"
            :placeholder="subject.default_select_text || '請選擇'"
            :disabled="subject.disabled"
          />
        </SubjectLayout>
      </template>
      <!-- type: shop selection end -->
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import collectionApi from "@/apis/liff/v2/collection";
import DynamicFormDateTimePicker from "@/components/DynamicForm/DateTimePicker.vue";
import DynamicFormDatePicker from "@/components/DynamicForm/DatePicker.vue";
import DynamicFormTimePicker from "@/components/DynamicForm/TimePicker.vue";
import AppFileUploader from "@/components/AppFileUploader.vue";
import ShopSelection from "@/components/Page/Liff/Branch/ShopSelection";
import ShopSubsetSelection from "@/components/Page/Liff/Branch/ShopSubsetSelection";
import Collection from "@/models/Collection.model.js";
import DynamicFormField from "@/models/DynamicFormField.model"
import DynamicFormValuePresenter from "@/presenters/DynamicFormValue.presenter"
import { validationRules } from '@/utils/DynamicFormUtils';
import SubjectLayout from "./SubjectLayout.vue";
import SharedSelect from "./Select";
import SharedRadioButton from "./Radio";
import SharedCheckbox from "./MultiCheckbox";
import CarouselSelection from "./CarouselSelection";
import CollectionSelect from "./CollectionSelect";
import PhoneVerification from "@/components/PhoneVerification.vue";
import deepGet from "lodash/get";

export default {
  components: {
    DynamicFormDateTimePicker,
    DynamicFormDatePicker,
    DynamicFormTimePicker,
    AppFileUploader,
    ShopSelection,
    ShopSubsetSelection,
    SubjectLayout,
    SharedSelect,
    SharedRadioButton,
    SharedCheckbox,
    CarouselSelection,
    CollectionSelect,
    PhoneVerification,
  },
  props: {
    inputSubjects: {
      type: Array,
      default: () => ([]),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    validationFilter: { // NOTE: 條件式的決定哪些 subject 需要被驗證
      type: Function,
      default: () => {
        return (subject) => true // eslint-disable-line
      },
    },
    branchFetching: {
      type: Boolean,
      default: false,
    },
    optionDisabler: {
      type: Function,
      default: (subject, option) => false // eslint-disable-line
    },
    phoneVerificationConfig: {
      type: Object,
      default: () => ({ enabled: false, field_id: null })
    },
  },
  watch: {
    form: {
      handler: function (val) {
        this.$emit("input", val);
      },
      immediate: true,
    },
    value: {
      handler: function (val) {
        this.form = val;
      },
      immediate: true,
    },
  },
  data() {
    return {
      form: this.value || {},
    };
  },
  computed: {
    subjects() {
      return DynamicFormField.fromArray(this.inputSubjects).map(fieldModel => ({
        ...fieldModel.flattenedAttributes(),
        id: fieldModel._id,
      }))
    },
  },
  setup: () => ({ v$: useVuelidate({ $lazy: true }) }),
  validations() {
    return {
      form: this.subjects
        .filter(this.validationFilter)
        .reduce(
          (cumulatedRules, subject) => {
            const rules = {};

            if (subject.required) {
              rules['required'] = required;
            }

            if (subject.validation_rules) {
              const matchedRule = validationRules[subject.type][subject.validation_rules]
              rules[subject.validation_rules] = helpers.withMessage(matchedRule.message, matchedRule.validator);
            }

            return { ...cumulatedRules, [subject.id]: rules }
          },
          {}
        )
    }
  },
  methods: {
    deepGet,
    handleFileUploading(val) {
      this.$emit('file-uploading', val)
    },
    displayPlaceholder(subject, defaultMessage = null) {
      if (subject.placeholder) return subject.placeholder;
      if (defaultMessage !== null) return defaultMessage;
      return "";
    },
    async validate() {
      const result = await this.v$.$validate();

      if (!result) {
        const element = document.getElementById(this.v$.$errors[0].$property);
        element.scrollIntoView({ behavior: "smooth" });
        console.warn("[DynamicForm] Validation failed.");
        return false;
      }

      // Check phone verification if enabled
      if (this.phoneVerificationConfig?.enabled && this.phoneVerificationConfig?.field_id) {
        const phoneVerificationComponents = this.$refs?.phoneVerification || []
        for (const component of phoneVerificationComponents) {
          if (component && !component.validate()) {
            component.$el.scrollIntoView({ behavior: "smooth" });
            console.warn("[DynamicForm] Phone verification not completed.");
            return false;
          }
        }
      }

      return true;
    },
    availableOptions(subject) {
      return (new DynamicFormField(subject)).availableOptionsForCustomer
    },
    optionsWithPlaceholder(subject) {
      const options = this.availableOptions(subject)
      if (subject.placeholder) {
        options.unshift({ text: subject.placeholder, value: null })
      }
      return options
    },
    carouselSelectionIsEnabled(subject) {
      return false === (!!subject[`branch_field_id`] && !this.getBranchIdByFieldId(subject[`branch_field_id`]))
    },
    async fetchCollectionItemsForCarousel(subject, fieldId = null) { // NOTE: 若 DynamicForm 與 DynamicFormDashboard 需要合併，則將此段邏輯改以 vue provide/inject 方式實作
      try {
        let collection;
        const isRelatedToBranch = !!fieldId
        if (isRelatedToBranch) {
          if (this.getBranchIdByFieldId(fieldId)) {
            collection = deepGet(await collectionApi.getOptionsForBranch(subject.collection_id, this.getBranchIdByFieldId(fieldId)), 'data.data', null);
          } else {
            return []
          }
        } else {
          collection = deepGet(await collectionApi.getCollection(subject.collection_id), 'data.data', null)
        }
        const collectionModel = new Collection(collection)

        const getValueFromCollectionItemByFieldId = (collectionItem, fieldId) => {
          if (fieldId === 'default') {
            return collectionModel.textForOption(collectionItem.id)
          }
          return deepGet(collectionItem.data.find(field => field.field_id === fieldId), 'value', null)
        }

        return collection.items.sort((a, b) => a.order - b.order).map((item) => ({
          id: item.id,
          title: getValueFromCollectionItemByFieldId(item, subject[`collection_title`]),
          image: getValueFromCollectionItemByFieldId(item, subject[`collection_image`]),
          description: getValueFromCollectionItemByFieldId(item, subject[`collection_description`]),
          value: DynamicFormValuePresenter.collectionItem(subject, item, collection),
          placeholderWhenSelected: collectionModel.textForOption(item.id),
        }))
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", `讀取 ${subject.title} 選項時發生錯誤，請重新整理後再試一次`, "error")
        return []
      }
    },
    matchCandidateForCollectionCarousel(candidate, incomingValue) {
      if (Array.isArray(incomingValue)) {
        return deepGet(candidate, 'value.collection_id') === deepGet(incomingValue[0], 'collection_id') &&
          deepGet(candidate, 'value.collection_item_id') === deepGet(incomingValue[0], 'collection_item_id')
      } else {
        return deepGet(candidate, 'value.collection_id') === deepGet(incomingValue, 'collection_id') &&
          deepGet(candidate, 'value.collection_item_id') === deepGet(incomingValue, 'collection_item_id')
      }
    },
    async prepareBranchBondCollectionItems() {
      return await Promise.all(
        this.inputSubjects
          .filter(subject => subject.type === 'shop_selection')
          .map(subject => {
            this.updateCollectionItemsByBranchFieldId(subject._id)
          })
      )
    },
    async prepareOptionsForShopSelections() {
      await Promise.all(
        this.inputSubjects
          .filter(subject => subject.type === 'shop_selection')
          .map(subject => {
            if (deepGet(subject, 'branch_population', 'all') === 'all') {
              this.$refs[`shop-selection-${subject._id}`][0].fetchBranchesOptions()
            }
            if (deepGet(subject, 'branch_population', 'all') === 'subset') {
              this.$refs[`shop-subset-selection-${subject._id}`][0].fetchBranchesOptions()
            }
          })
      )
    },
    async prepareOptionsForCollectionSelects() {
      await Promise.all(
        this.inputSubjects
          .filter(subject => subject.type === 'collection_select' && !subject.branch_field_id)
          .map(subject => {
            this.$refs[`collection-select-${subject._id}`][0].fetchCollectionItems()
          })
      )
    },
    handleShopSelectionChange(event, subject) {
      if (event.type === 'shop') {
        this.$set(this.form, subject.id, {
          branch_provider: subject.branch_provider,
          text: deepGet(event, 'model.name'),
          value: deepGet(event, 'model.id'),
        })
      } else {
        this.$set(this.form, subject.id, null)
      }

      this.handleFieldValueChanged(this.form[subject.id], subject)

      this.$nextTick(() => {
        this.updateCollectionItemsByBranchFieldId(subject._id)
        this.outputBranchSelectResult(event.id, subject._id, event.type)
      })
    },
    handleShopSubsetSelectionChange(shopModel, subject) {
      if (shopModel === null) {
        this.$set(this.form, subject.id, null)
      } else {
        this.$set(this.form, subject.id, {
          text: deepGet(shopModel, 'name'),
          value: deepGet(shopModel, 'id'),
        })
      }

      this.handleFieldValueChanged(this.form[subject.id], subject)

      this.$nextTick(() => {
        this.updateCollectionItemsByBranchFieldId(subject._id)
        this.outputBranchSelectResult(deepGet(shopModel, 'id', null), subject._id, shopModel === null ? 'area' : 'shop')
      })
    },
    outputBranchSelectResult(branchId, fieldId, type) {
      this.$emit('outputBranchSelectResult', {
        branchId,
        fieldId,
        type
      })
    },
    async updateCollectionItemsByBranchFieldId(fieldId) {
      const relatedCollectionSelects = this.inputSubjects.filter(inputSubject => inputSubject.branch_field_id === fieldId)
      relatedCollectionSelects.filter(collectionSelect => collectionSelect.type === 'collection_select').map(collectionSelect => {
        this.$refs[`collection-select-${collectionSelect._id}`][0].fetchCollectionItems()
      })
      relatedCollectionSelects.filter(collectionCarousel => collectionCarousel.type === 'collection_carousel').map(collectionCarousel => {
        this.$refs[`collection-carousel-${collectionCarousel._id}`][0].fetchCandidates()
      })
    },
    getBranchIdByFieldId(fieldId) {
      return deepGet(this.form, `${fieldId}.value`, null)
    },
    handleFieldValueChanged(value, subject) {
      this.$emit('diff', value, subject)
    },
    isPhoneVerificationField(subject) {
      return this.phoneVerificationConfig?.enabled &&
        this.phoneVerificationConfig?.field_id === subject.id
    },
    // public api: prepare options for shop selection, shop subset selection, collection select, collection carousel
    // recommend: calling this method once after inputSubjects and form are set
    async fetchAllAsyncOptions() {
      await Promise.all([
        this.prepareOptionsForShopSelections(),
        this.prepareBranchBondCollectionItems(),
        this.prepareOptionsForCollectionSelects(),
      ])
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/shared/components/_fields.scss";

body {
  --liff-button-color: #cccccc;
}

::v-deep .field {
  &__label {
    font-size: 20px;
    font-weight: 500;
    color: var(--liff-primary_text_color);
  }
  &__input {
    font-size: 18px;
    background-color: #ffffff;
    color: var(--liff-primary_text_color);
  }

  &__desc {
    font-size: 14px !important;
    color: var(--liff-secondary_text_color);
  }

  &--required {
    &:after {
      content: "*";
      position: relative;
      font-family: "PingFang TC";
      color: var(--s-primary);
      margin-left: 2px;
    }
  }
}

.row {
  margin: 0 -0.5rem;
}
</style>
